var ctrlopt = ctrlopt,
  generic = generic || {},
  moment = moment || {};
var userData;
(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var OAB_price_override =
    Drupal.settings.globals_variables.OAB_override_price_format !== 'undefined'
      ? Drupal.settings.globals_variables.OAB_override_price_format
      : 0;
  var settings = Drupal.settings || {};
  var oab = settings.globals_variables || {};
  var OAB_date_override =
    oab.OAB_override_date_format !== 'undefined' ? oab.OAB_override_date_format : 0;
  var OAB_time_year_first = oab.OAB_time_year_first !== 'undefined' ? oab.OAB_time_year_first : 0;
  var oab_year_suffix = oab.oab_year_suffix ? oab.oab_year_suffix : '';
  var oab_day_suffix = oab.oab_day_suffix ? oab.oab_day_suffix : '';
  var OAB_price_no_decimal = oab.OAB_price_no_decimal || 0;
  var isDisablePrice = +$('#appointment-book-container').attr('data-disable-price');
  var oab_moment_js_locale = oab.oab_moment_js_locale || '';
  var oab_disable_appt_end_time = settings.oab_end_time_hide;

  /* Concrete View */
  apptBook.myAppts = {
    init: function () {
      var curApptData,
        pastApptData,
        token,
        me = this,
        suppressLinks = false,
        container = $('#appointment-book-container'),
        apptCont = $('#account-my-appointments'),
        curAppts = $('#my-appointments-current'),
        pastAppts = $('#my-appointments-past'),
        viewPastBtn = pastAppts.find('#my-appointments-view-past-link'),
        viewMakeupLessons = $('#view-makeup-lessons-btn'),
        curApptTmpl = curAppts.find('.appointment-container').remove().first(),
        pastApptTmpl = pastAppts.find('.appointment-container').remove().first(),
        overlay = $('#appt-book-my-appointments-overlay'),
        closeBtn = overlay.find('.overlay-close'),
        overlayConf = overlay.find('#confirm-cancel'),
        overlayCanc = overlay.find('#appt-canceled'),
        yesBtn = overlayConf.find('.yes-btn'),
        noBtn = overlayConf.find('.no-btn'),
        noAppts = $('#appt-book-my-appointments-no-appts').remove(),
        noSignin = $('#appt-book-my-appointments-no-signin').remove(),
        months = apptCont.attr('data-month-names').split(','),
        minLabel = apptCont.attr('data-minutes-label'),
        curSymbol = apptCont.attr('data-currency-symbol'),
        atCopy = Drupal.settings.globals_variables.OAB_at_copy
          ? Drupal.settings.globals_variables.OAB_at_copy
          : 'at',
        $bod = $('body'),
        isSignedIn = 0,
        totalDuration = 0,
        curApptsCount,
        momentLocale =
          apptCont.attr('data-moment-locale') ||
          (generic.cookie('LOCALE') ? generic.cookie('LOCALE').substr(0, 2) : 'en');

      moment.locale(momentLocale);

      viewMakeupLessons.click(function (e) {});

      function openOverlay(apptId) {
        $bod.prepend(overlay);
        overlay.css('display', 'block');
        overlayConf.css('display', 'block');
        overlayCanc.css('display', 'none');

        closeBtn.off('click').click(function (e) {
          e.preventDefault();
          closeOverlay();
        });

        yesBtn.off('click').click(function (e) {
          e.preventDefault();
          cancelAppointment(apptId, onCanceled);
        });

        noBtn.off('click').click(function (e) {
          e.preventDefault();
          closeOverlay();
        });
      }

      function closeOverlay() {
        overlay.remove();
      }

      // Override moment JS for only india/hindi to translate AM PM
      function overrideMomentHindiJs() {
        if (momentLocale === oab_moment_js_locale && oab_moment_js_locale === 'hi') {
          moment.defineLocale(oab_moment_js_locale, {
            meridiem: function (hour) {
              if (hour < 4) {
                return 'रात';
              } else if (hour < 12) {
                return 'सुबह';
              } else if (hour < 17) {
                return 'दोपहर';
              } else if (hour < 20) {
                return 'शाम';
              } else {
                return 'रात';
              }
            }
          });
        }
      }

      function onCanceled(r) {
        var apptHrStr,
          apptTimeStr,
          locString,
          out,
          totalDuration = 0,
          p = overlayCanc.find('p').empty(),
          apptId = r.id,
          servs = r.services,
          date = me.convertTimeString(r.start_time),
          dateEnd = new Date(),
          counter = r.counter,
          virtual = r.calendar.virtual,
          span = $('<span></span>'),
          apptCont = $('#account-my-appointments'),
          dateFormat = apptCont.attr('data-date-format') || 'MMM D, YYYY',
          timeFormat = apptCont.attr('data-time-format') || 'hh:mma';

        overlayConf.css('display', 'none');
        overlayCanc.css('display', 'block');

        for (var i = 0, len = servs.length; i < len; i += 1) {
          var serv = servs[i];

          serv.price = serv.price || 0;
          serv.price = OAB_price_no_decimal ? parseInt(serv.price) : serv.price;

          totalDuration += parseInt(serv.total_duration);
          if (isDisablePrice && !+serv.price) {
            out = span.clone().text(serv.name + ' - ' + serv.total_duration + minLabel);
          } else {
            out = span
              .clone()
              .text(
                serv.name + ' - ' + serv.total_duration + minLabel + ' / ' + curSymbol + serv.price
              );
          }
          p.append(out);
        }

        dateEnd.setTime(date.getTime() + parseInt(totalDuration) * 60000);

        apptHrStr = moment(date).format(timeFormat) + ' - ' + moment(dateEnd).format(timeFormat);
        // This will override moment JS to translate AM PM for only hindi language.
        overrideMomentHindiJs();
        // Moment adds '.' to the end of short month names for a lot of locales and we do not want it.
        apptTimeStr =
          moment(date).format(dateFormat).replace('.', '') + ' ' + atCopy + ' ' + apptHrStr;

        out = span.clone().text(apptTimeStr);
        p.append(out);

        if (!Number(virtual)) {
          locString = counter.town + ' - ' + counter.name + ', ' + counter.address1;
        }

        out = span.clone().text(locString);
        p.append(out);

        $('#apptId_' + apptId).remove();

        curApptsCount -= 1;
        if (curApptsCount <= 0) {
          curAppts.remove();
          apptCont.prepend(noAppts);
        }
      }

      function setLangValue(params) {
        if (Drupal.settings.globals_variables && Drupal.settings.globals_variables.set_appt_lang) {
          params.lang = apptBook.sectionModel.getLanguage();
        }
      }

      /* functions for building appointments*/

      function getAuthToken(callback) {
        generic.jsonrpc.fetch({
          method: 'appointmentbooking.getauthtoken',
          onSuccess: function (rpc) {
            token = rpc.getValue().auth_token;
            if (typeof callback === 'function') {
              callback(token);
            }
          },
          onError: function (rpc) {
            // console.log("Error getting authorization token");
          }
        });
      }

      function getCounters() {
        var url = 'https://' + window.location.hostname + '/_abapi/api/v1/counters',
          params = {
            token: token
          };

        setLangValue(params);
        $.ajax({
          url: url,
          type: 'GET',
          data: params,
          success: function (r) {
            if (!r || !r.length) {
              viewMakeupLessons.remove();
              suppressLinks = true;
            }
          },

          error: function (err) {
            // console.log('Error: ' + err.status);
            /* var r = JSON.parse(err.responseText);
               if (typeof errorCallback === 'function') {
               errorCallback(r);
               }*/
            viewMakeupLessons.remove();
            suppressLinks = true;
          }
        });
      }

      function getAppointments(callback, errorCallback) {
        var url = 'https://' + window.location.hostname + '/_abapi/api/v1/appointments',
          params = {
            token: token
          };

        setLangValue(params);
        $.ajax({
          url: url,
          type: 'GET',
          data: params,
          success: function (r) {
            if (typeof callback === 'function') {
              // var resp = JSON.parse(r);
              callback(r);
            }
          },

          error: function (err) {
            // console.log('Error: ' + err.status);
            /* var r = JSON.parse(err.responseText);
              if (typeof errorCallback === 'function') {
                errorCallback(r);
              }*/
            buildNoAppts();
          }
        });
      }

      function cancelAppointment(id, callback, errorCallback) {
        var url = 'https://' + window.location.hostname + '/_abapi/api/v1/appointments/' + id,
          params = {
            token: token,
            _method: 'DELETE'
          };

        setLangValue(params);
        $.ajax({
          url: url,
          type: 'POST',
          data: params,
          success: function (r) {
            if (typeof callback === 'function') {
              // var resp = JSON.parse(r);
              callback(r);
            }
          },

          error: function (err) {
            // console.log('Error: ' + err.status);
          }
        });
      }

      function buildCurrentLessons(node, data) {
        var myData,
          myLTmpl,
          myLNTmpl,
          myLDTmpl,
          myNode,
          myLName,
          myLTime,
          myLPrice,
          servicesName,
          durationsPrices,
          lessonsName,
          lessonsDetails,
          me = this,
          separator = ' / ';

        totalDuration = 0;

        if (!site.client.isMobile || $('html').attr('lang') === 'he-IL') {
          servicesName = node.find('.services-name');
          durationsPrices = node.find('.duration-price');
          lessonsName = servicesName.find('.lesson-name').remove();
          lessonsDetails = durationsPrices.find('.lesson-details').remove();

          for (var i = 0, len = data.length; i < len; i += 1) {
            myData = data[i];
            myData.price = myData.price || 0;
            myLNTmpl = lessonsName.clone();
            myLDTmpl = lessonsDetails.clone();
            myLName = myData.name;
            myLTime = myData.total_duration;
            myLPrice = OAB_price_no_decimal ? parseInt(myData.price) : myData.price;
            if (isDisablePrice && !+myLPrice) {
              myLPrice = '';
              curSymbol = '';
              separator = '';
            }
            totalDuration += parseInt(myLTime);

            myLNTmpl.html(myLName + ':');
            myLDTmpl.html(myLTime + ' ' + minLabel + separator + curSymbol + myLPrice);
            if (OAB_price_override) {
              myLDTmpl.html(myLTime + ' ' + minLabel + separator + parseInt(myLPrice) + curSymbol);
            } else if ($('html').attr('dir') === 'rtl') {
              myLDTmpl.html(myLTime + minLabel + separator + curSymbol + myLPrice);
            } else {
              myLDTmpl.html(myLTime + ' ' + minLabel + separator + curSymbol + myLPrice);
            }
            servicesName.append(myLNTmpl);
            durationsPrices.append(myLDTmpl);
          }
        } else {
          myLTmpl = node.find('.lesson').remove().first();

          for (var i = 0, len = data.length; i < len; i += 1) {
            myData = data[i];
            myData.price = myData.price || 0;
            myNode = myLTmpl.clone();
            myLNTmpl = myNode.find('.lesson-name');
            myLDTmpl = myNode.find('.lesson-details');
            myLName = myData.name;
            myLTime = myData.total_duration;
            myLPrice = OAB_price_no_decimal ? parseInt(myData.price) : myData.price;
            if (isDisablePrice && !+myLPrice) {
              myLPrice = '';
              curSymbol = '';
              separator = '';
            }
            totalDuration += parseInt(myLTime);

            if (myLNTmpl.length && myLDTmpl.length) {
              myLNTmpl.html(myLName + ':');
              myLDTmpl.html(
                OAB_price_override
                  ? myLTime + ' ' + minLabel + separator + parseInt(myLPrice) + curSymbol
                  : myLTime + ' ' + minLabel + separator + curSymbol + myLPrice
              );
            } else {
              if (i == 0) {
                myNode.html(myLName);
              } else {
                myNode.html(' / ' + myLName);
              }
            }
            node.append(myNode);
          }
        }
      }

      function buildLessons(node, data) {
        var myData,
          myLTmpl,
          myLNTmpl,
          myLDTmpl,
          myNode,
          myLName,
          myLTime,
          myLPrice,
          me = this,
          separator = ' / ';

        myLTmpl = node.find('.lesson').remove().first();

        totalDuration = 0;

        for (var i = 0, len = data.length; i < len; i += 1) {
          myData = data[i];
          myData.price = myData.price || 0;
          myNode = myLTmpl.clone();
          myLNTmpl = myNode.find('.lesson-name');
          myLDTmpl = myNode.find('.lesson-details');
          myLName = myData.name;
          myLTime = myData.total_duration;
          myLPrice = OAB_price_no_decimal ? parseInt(myData.price) : myData.price;
          if (isDisablePrice && !+myLPrice) {
            myLPrice = '';
            curSymbol = '';
            separator = '';
          }
          totalDuration += parseInt(myLTime);

          if (myLNTmpl.length && myLDTmpl.length) {
            myLNTmpl.html(myLName + ':');
            myLDTmpl.html(myLTime + ' ' + minLabel + separator + curSymbol + myLPrice);
          } else {
            if (i == 0) {
              myNode.html(myLName);
            } else {
              myNode.html(' / ' + myLName);
            }
          }
          node.append(myNode);
        }
      }

      function buildVirtualLocation(node, meetingLink) {
        var apptHyperlink = node.find('.virtual-appt-link');

        if (meetingLink) {
          apptHyperlink.attr('href', meetingLink).text(meetingLink);
        }
      }

      function buildLocation(node, data) {
        var tpStr = '',
          googleStr = 'https://www.google.com/maps?daddr=',
          name = data.name,
          addr1 = data.address1,
          addr2 = data.address2,
          town = data.town,
          county = data.county,
          postCode = data.postcode,
          phone = data.phone,
          email = data.email,
          nameNode = node.find('.location-name'),
          addrNode = node.find('.location-address'),
          addr2Node = node.find('.location-address2'),
          townPostNode = node.find('.location-town-postcode'),
          phoneNode = node.find('.location-phone'),
          getDir = node.find('.location-direction-links');

        if (name) {
          nameNode.html(name);
          googleStr += name;
        } else {
          nameNode.hide();
        }

        if (addr1) {
          addrNode.html(addr1);
          googleStr += '+' + addr1;
        } else {
          addrNode.hide();
        }

        if (addr2) {
          addr2Node.html(addr2);
          googleStr += '+' + addr2;
        } else {
          addr2Node.hide();
        }

        if (town) {
          tpStr += town;
          googleStr += '+' + town;
        }

        if (county) {
          tpStr += tpStr === '' ? county : ', ' + county;
          googleStr += '+' + county;
        }

        if (postCode) {
          tpStr += tpStr === '' ? postCode : ', ' + postCode;
          googleStr += '+' + postCode;
        }

        if (tpStr === '') {
          townPostNode.hide();
        } else {
          townPostNode.html(tpStr);
        }

        if (phone) {
          phoneNode.html(phone);
          if (typeof phoneNode.attr('href') !== 'undefined') {
            phoneNode.attr('href', 'tel:' + phone);
          }
        } else {
          phoneNode.hide();
        }

        getDir.attr('href', googleStr);
        getDir.click(function (e) {});
      }

      function buildDateTime(node, data, isVirtual) {
        var apptDayStr,
          apptHrStr,
          apptStartDate = data.startDate,
          apptEndDate = new Date(apptStartDate.getTime()),
          dateNode = node.find('.appt-date'),
          dateDay = dateNode.find('.appt-date-day'),
          dateHours = dateNode.find('.appt-date-hours'),
          calContainer = node.find('.appt-date-cal'),
          apptCont = $('#account-my-appointments'),
          dateFormat = apptCont.attr('data-date-format') || 'MMM D, YYYY',
          timeFormat = apptCont.attr('data-time-format') || 'hh:mma',
          calLocation;

        if (calContainer.length) {
          var typeClass = isVirtual ? '.virtual' : '.physical',
            addCalDesc =
              calContainer.find('.add-cal-desc' + typeClass).html() ||
              "Your Makeup Appointment is booked! Please arrive ten minutes before your lesson. We're looking forward to seeing you in person.",
            addCalLink = calContainer.find('.add-cal-link'),
            calLinks = calContainer.find('.date-time-link'),
            addCalTitle = calContainer.find('.add-cal-title').html() || 'MAC Appointment',
            addr1 = data.counter.address1 || '',
            addr2 = data.counter.address2 || '',
            town = data.counter.town || '',
            county = data.counter.county || '',
            postcode = data.counter.postcode || '',
            virtMeetingLink = data.virtual_meeting_link;

          if (isVirtual) {
            calLocation = virtMeetingLink;
          } else {
            calLocation =
              addr1 + ', ' + town + ', ' + (county !== '' ? county + ' ' : '') + postcode;
          }
        }

        apptEndDate.setTime(apptEndDate.getTime() + parseInt(totalDuration) * 60000);

        // This will override moment JS to translate AM PM for only hindi language.
        overrideMomentHindiJs();
        // Moment adds '.' to the end of short month names for a lot of locales and we do not want it.
        apptDayStr = moment(apptStartDate).format(dateFormat).replace('.', '');

        if (oab_disable_appt_end_time) {
        apptHrStr = moment(apptStartDate).format(timeFormat);
        } else {
        apptHrStr = moment(apptStartDate).format(timeFormat) + ' - ' + moment(apptEndDate).format(timeFormat);
        }

        dateDay.text(apptDayStr);
        dateHours.text(apptHrStr);

        if (calContainer.length) {
          me.myCalendar = createCalendar({
            data: {
              device_mobile: site.client.isMobile,
              title: addCalTitle, // Event title
              start: apptStartDate, // Event start date
              duration: totalDuration, // Event duration (IN MINUTES)
              end: apptEndDate, // You can also choose to set an end time. If an end time is set, this will take precedence over duration
              address: calLocation,
              description: addCalDesc
            }
          });

          calLinks.each(function () {
            var $this = $(this);
            var calID = $(this).attr('data-cal'),
              data = $.grep(me.myCalendar, function (el, i) {
                if (el.calId.toLowerCase() === calID) {
                  return el.calHref;
                }
              });
            var dataUri = data[0].calHref;

            createDownloadLink($this, dataUri, calID, 'calendar.ics');

            $this.on('click', function () {
              var calLinksCont = $(this).parents('.cals-container');

              expanded = addCalLink.attr('aria-expanded');
              calLinksCont.toggleClass('expanded');
              expanded == 'false'
                ? addCalLink.attr('aria-expanded', 'true')
                : addCalLink.attr('aria-expanded', 'false');
              addCalLink.focus();
            });
            $this.on('keydown', function (e) {
              if (site.getKeycode(e) === 13) {
                $(this).trigger('click');
              }
            });

            function createDownloadLink(anchorSelector, dataUri, calID, fileName) {
              var dateUriIE = '';
              var blobObject = null;

              if (window.navigator.msSaveOrOpenBlob && calID !== 'google') {
                dateUriIE = dataUri.split(',')[1];
                dateUriIE = decodeURIComponent(dateUriIE);
                var fileData = [dateUriIE];

                blobObject = new Blob(fileData);
                $(anchorSelector).click(function (e) {
                  e.preventDefault();
                  window.navigator.msSaveOrOpenBlob(blobObject, fileName);
                });
              } else {
                $(anchorSelector).attr('href', dataUri);
              }
            }
          });

          addCalLink.on('click', function () {
            var calLinksCont = $(this).parent().find('.cals-container');
            var expanded = $(this).attr('aria-expanded');

            calLinksCont.toggleClass('expanded');
            expanded == 'false'
              ? $(this).attr('aria-expanded', 'true')
              : $(this).attr('aria-expanded', 'false');
          });
          addCalLink.on('keydown', function (e) {
            if (site.getKeycode(e) === 13) {
              $(this).trigger('click');
            }
          });
        }
      }

      function buildArtistName(node, data) {
        var aName = data.public_name,
          aNameNode = node.find('.artist-name');

        aNameNode.html(aName);
      }

      function buildView(node, apptId) {
        var viewBtn = node.find('.view-link').off('click');

        if (!site.client.isMobile) {
          viewBtn.each(function () {
            $(this).addClass('disabled').hide();
          });
        } else {
          viewBtn.each(function () {
            var btn = $(this),
              closeH,
              openH,
              container = btn.closest('.appointment-container');

            dateTime = container.find('.date-time');

            closeH = dateTime.height();
            openH = container.height();
            container.height(closeH);
            container.addClass('js-mobile-hidden');

            btn.on('click', function (e) {
              e.preventDefault();
              var $this = $(this);

              if ($this.hasClass('disabled')) {
                return;
              }

              $this.addClass('disabled');

              container.toggleClass('js-mobile-hidden');
              if (container.hasClass('js-mobile-hidden')) {
                container.animate({ height: closeH + 'px' }, 700, function () {
                  $this.removeClass('disabled');
                });
              } else {
                container.animate({ height: openH + 'px' }, 700, function () {
                  $this.removeClass('disabled');
                });
              }
            });
          });
        }
      }

      function buildNoAppts() {
        apptCont.empty();
        apptCont.append(noAppts);
        if (suppressLinks) {
          noAppts.find('.button').remove();
        }
      }

      function buildNoSignin() {
        apptCont.append(noSignin);

        var noSignInContainer = container.find('#appt-book-my-appointments-no-signin'),
          header = noSignInContainer.find('.appt-book-content-header'),
          signInHeader = header.find('.sign-in-title'),
          signUpHeader = header.find('.sign-up-title'),
          errorContainer = noSignInContainer.find('#appt-book-my-appts-error-messages').hide(),
          errorMessages = errorContainer.find('.error-message'),
          // Sign In Fields
          signInContainer = noSignInContainer.find('.sign-in-container'),
          signInLink = signInContainer.find('#my-appts-sign-up-link').off('click'),
          signInEmail = signInContainer.find('#my-appts-login-email'),
          signInPw = signInContainer.find('#my-appts-login-password'),
          signInBtn = signInContainer.find('#my-appts-login-submit').off('click'),
          forgotPasswordLink = signInContainer.find('.js-forgot-password').off('click'),
          hiddenForm = signInContainer.find('.js-signin-hidden-form'),
          // Sign Up Fields
          signUpContainer = noSignInContainer.find('.registration-container'),
          signUpLink = signUpContainer.find('#my-appts-sign-in-link').off('click'),
          fNameInput = signUpContainer.find('.registration-first-name'),
          lNameInput = signUpContainer.find('.registration-last-name'),
          emailInput = signUpContainer.find('.registration-email'),
          phoneInput = signUpContainer.find('.registration-mobile'),
          checkboxInput = container.find('input[type=checkbox]'),
          signUpPw = signUpContainer.find('.registration__password'),
          signUpEmailInput = signUpContainer.find('.registration__email-list').find('input'),
          signUpSMSInput = signUpContainer.find('.registration__sms-list').find('input'),
          signUpPrivacyInput = signUpContainer.find('.registration__privacy-list').find('input'),
          signUpPrivacyContainer = signUpContainer.find('.registration__privacy_policy-container'),
          signUpBtn = signUpContainer.find('#my-appts-registration-submit').off('click'),
          emailPromotionsLabel = signUpContainer.find('.registration__email-list');

        signInContainer.show();
        signInHeader.show();
        signUpContainer.hide();
        signUpHeader.hide();

        checkboxInput.picker();

        signUpPrivacyContainer.find('label a').on('tap click', function (e, data) {
          e.stopPropagation();
          e.preventDefault();
          window.open($(this).attr('href'), $(this).attr('target'));

          return false;
        });

        if (settings.fb_login_app_id && site.facebook && typeof FB === 'object') {
          site.facebook.init();
        }

        if (settings.validate_password_enabled) {
          Drupal.behaviors.passwordTooltipIndicatorV1.attach();
        }
        signInLink.on('click', function (e) {
          e.preventDefault();
          signInContainer.hide();
          signInHeader.hide();
          signUpContainer.show();
          signUpHeader.show();
          errorMessages.css('display', 'none');
          signInContainer.find('input').removeClass('error');
        });
        signInBtn.on('click', function (e) {
          e.preventDefault();
          var $this = $(this),
            isEmptyField = 0,
            params = [];

          if ($this.hasClass('disabled')) {
            return;
          }

          $this.addClass('disabled');

          params.push({
            _SUBMIT: 'signin',
            EMAIL_ADDRESS: signInEmail.val(),
            PASSWORD: signInPw.val()
          });

          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: JSON.stringify(params),
            onSuccess: function (jsonRpcResponse) {
              signInBtn.removeClass('disabled');
              onUpdate();
            },
            onFailure: function (jsonRpcResponse) {
              var errObjs = jsonRpcResponse.getMessages();

              errorContainer.css('display', 'block');
              errorMessages.css('display', 'none');
              signInContainer.find('input').removeClass('error');

              for (var i = 0; i < errObjs.length; i += 1) {
                var myErr = errObjs[i];

                if (myErr && myErr.key) {
                  if (
                    myErr.key === 'required.password.signin' ||
                    myErr.key === 'required.password.signin.app'
                  ) {
                    signInPw.addClass('error');
                    errorMessages.filter('#error-signin-password').css('display', 'block');
                  }

                  if (
                    myErr.key === 'invalid.password.signin' ||
                    myErr.key === 'invalid.password.signin.app' ||
                    myErr.key === 'format.password.signin'
                  ) {
                    signInPw.addClass('error');
                    errorMessages.filter('#error-signin-invalid-password').css('display', 'block');
                  }

                  if (
                    myErr.key === 'required_or.email_address.device_id.required_or.signin' ||
                    myErr.key === 'required_or.email_address.device_id.required_or.signin.app'
                  ) {
                    signInEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').css('display', 'block');
                  }

                  if (
                    myErr.key === 'required.email_address.signin' ||
                    myErr.key === 'required.email_address.signin.app'
                  ) {
                    signInEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').css('display', 'block');
                  }

                  if (
                    myErr.key === 'invalid.email_address.signin' ||
                    myErr.key === 'invalid.email_address.signin.app'
                  ) {
                    signInEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').css('display', 'block');
                  }

                  if (
                    myErr.key === 'no_account..signin' ||
                    myErr.key === 'no_account..signin.app'
                  ) {
                    signInEmail.addClass('error');
                    signInPw.addClass('error');
                    errorMessages.filter('#error-signin-no-account').css('display', 'block');
                  }
                  if (myErr.key === 'account_lockout' || myErr.key === 'account_lockout.app') {
                    errorMessages.filter('#error-signin-account-lockout').css('display', 'block');
                  }
                }
              }

              generic.focusErrors($('.js-error-messages'), $('.js-sign-in-container'));
              $this.removeClass('disabled');
            }
          });
        });

        forgotPasswordLink.on('click', function (e) {
          e.preventDefault();

          // Reset the Error messages
          errorMessages.css('display', 'none');
          errorContainer.css('display', 'none');
          signInContainer.find('input, textarea, .label, .picker-handle').removeClass('error');

          email = signInEmail.val(); // Take the Signin Email field value.
          actionURL = forgotPasswordLink.attr('href');

          if (!hiddenForm || !actionURL) {
            return null;
          }
          if (!email) {
            errorContainer.css('display', 'block');
            signInEmail.addClass('error');
            errorMessages.filter('#error-signin-email').css('display', 'block');

            return null;
          }

          var hiddenEmailNode = hiddenForm.find('.js-hidden-email');

          hiddenEmailNode.val(email);

          var hiddenReturnNode = hiddenForm.find('.js-hidden-return'),
            returnURL = window.location.pathname;

          hiddenReturnNode.val(returnURL);

          hiddenForm.submit();
        });

        signUpLink.on('click', function (e) {
          e.preventDefault();
          signInContainer.show();
          signInHeader.show();
          signUpContainer.hide();
          signUpHeader.hide();
          errorMessages.css('display', 'none');
          signUpContainer.find('input').removeClass('error');
          signUpPrivacyContainer.find('span.label').removeClass('error');
        });

        signUpBtn.on('click', function (e) {
          e.preventDefault();
          var $this = $(this),
            fName = fNameInput.val(),
            lName = lNameInput.val(),
            email = emailInput.val(),
            phone = phoneInput.val(),
            pass = signUpPw.val(),
            signUpEmail = signUpEmailInput.is(':checked') ? signUpEmailInput.val() : 0,
            signUpSMS = signUpSMSInput.is(':checked') ? signUpSMSInput.val() : 0,
            signUpPrivacy = signUpPrivacyInput.is(':checked') ? signUpPrivacyInput.val() : '',
            signUpEmailObj = {},
            params = [];

          e.preventDefault();

          if ($this.hasClass('disabled')) {
            return;
          }

          errorMessages.css('display', 'none');
          signUpContainer.find('input, textarea, .label, .picker-handle').removeClass('error');

          $this.addClass('disabled');

          function emptyInputs() {
            if (oab.appt_email_promotions_mandatory && !signUpEmailInput.is(':checked')) {
              errorMessages.filter('#error-oab-email-promotions').css('display', 'block');
              emailPromotionsLabel.find('span.label').addClass('error');
              signUpEmailInput.addClass('error');
            }
          }

          signUpEmailObj._SUBMIT = 'registration_short';
          signUpEmailObj.EMAIL_ADDRESS = emailInput.val();
          signUpEmailObj.PC_EMAIL_ADDRESS = emailInput.val();
          signUpEmailObj.PC_EMAIL_ADDRESS2 = emailInput.val();
          signUpEmailObj.PASSWORD = signUpPw.val();
          signUpEmailObj.PASSWORD2 = signUpPw.val();
          signUpEmailObj.FIRST_NAME = fNameInput.val();
          signUpEmailObj.LAST_NAME = lNameInput.val();
          signUpEmailObj.ACCEPTED_PRIVACY_POLICY = signUpPrivacy;
          signUpEmailObj.CAN_ADD_ADDRESS = 0;
          if (signUpEmail) {
            signUpEmailObj.PC_EMAIL_PROMOTIONS = 1;
          }

          if (signUpSMS) {
            signUpEmailObj._SECONDARY_SUBMIT = 'sms';
            signUpEmailObj.MOBILE_PHONE = phoneInput.val();
            signUpEmailObj.SMS_PROMOTIONS = 1;
          } else {
            signUpEmailObj._SECONDARY_SUBMIT = 'sms';
            signUpEmailObj.SMS_PROMOTIONS = 0;
          }

          params.push(signUpEmailObj);

          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: JSON.stringify(params),
            onSuccess: function (jsonRpcResponse) {
              signUpEmailObj._SUBMIT = 'registration';
              params = [];
              params.push(signUpEmailObj);
              generic.jsonrpc.fetch({
                method: 'rpc.form',
                params: JSON.stringify(params),
                onSuccess: function (jsonRpcResponse) {
                  signUpBtn.removeClass('disabled');
                  onUpdate();
                },
                onFailure: function (jsonRpcResponse) {
                  signUpBtn.removeClass('disabled');
                  onUpdate();
                }
              });
            },
            onFailure: function (jsonRpcResponse) {
              var errObjs = jsonRpcResponse.getMessages();
              var errorMessagePasswordId = '';

              errorContainer.css('display', 'block');
              errorMessages.css('display', 'none');
              signUpContainer.find('input').removeClass('error');
              signUpPrivacyContainer.find('span.label').removeClass('error');

              emptyInputs();

              for (var i = 0; i < errObjs.length; i += 1) {
                var myErr = errObjs[i];

                if (myErr && myErr.key) {
                  if (
                    (myErr.key === 'required.password.registration_short' ||
                      myErr.key === 'required.password.registration_short.app') &&
                    errorMessagePasswordId !== 'error-registration-min-max-password'
                  ) {
                    signUpPw.addClass('error');
                    errorMessagePasswordId = 'error-registration-password';
                    errorMessages.filter('#error-registration-password').css('display', 'block');
                    errorMessages
                      .filter('#error-registration-min-max-password')
                      .css('display', 'none');
                  }

                  if (
                    (myErr.key === 'invalid.password.registration_short' ||
                      myErr.key === 'invalid.password.registration_short.app') &&
                    errorMessagePasswordId !== 'error-registration-min-max-password'
                  ) {
                    signUpPw.addClass('error');
                    errorMessagePasswordId = 'error-registration-invalid-password';
                    errorMessages
                      .filter('#error-registration-invalid-password')
                      .css('display', 'block');
                    errorMessages.filter('#error-registration-password').css('display', 'none');
                    errorMessages
                      .filter('#error-registration-min-max-password')
                      .css('display', 'none');
                  }

                  if (
                    myErr.key === 'min_max.password.registration_short' ||
                    myErr.key === 'format.password.registration_short' ||
                    myErr.key === 'min_max.password.registration_short.app'
                  ) {
                    signUpPw.addClass('error');
                    errorMessagePasswordId = 'error-registration-min-max-password';
                    errorMessages
                      .filter('#error-registration-min-max-password')
                      .css('display', 'block');
                    errorMessages.filter('#error-registration-password').css('display', 'none');
                    errorMessages
                      .filter('#error-registration-invalid-password')
                      .css('display', 'none');
                  }

                  if (
                    myErr.key === 'required.pc_email_address.registration_short' ||
                    myErr.key === 'invalid.pc_email_address.registration_short' ||
                    myErr.key === 'required.pc_email_address.registration_short.app' ||
                    myErr.key === 'invalid.pc_email_address.registration_short.app'
                  ) {
                    emailInput.addClass('error');
                    errorMessages.filter('#error-registration-email').css('display', 'block');
                  }
                  if (
                    myErr.key === 'required.accepted_privacy_policy.registration_short' ||
                    myErr.key === 'required.accepted_privacy_policy.registration_short.app'
                  ) {
                    signUpPrivacyInput.addClass('error');
                    signUpPrivacyContainer.find('span.label').addClass('error');
                    errorMessages.filter('#error-signup-privacy-invalid').css('display', 'block');
                  }

                  if (
                    myErr.key === 'invalid.accepted_privacy_policy.registration_short' ||
                    myErr.key === 'invalid.accepted_privacy_policy.registration_short.app'
                  ) {
                    emailInput.addClass('error');
                    errorMessages.filter('#error-registration-email').css('display', 'block');
                    errorMessages.filter('#' + errorMessagePasswordId).css('display', 'block');
                  }

                  if (myErr.key === 'account_exists' || myErr.key === 'account_exists.app') {
                    emailInput.addClass('error');
                    errorMessages
                      .filter('#error-registration-account-exist')
                      .css('display', 'block');
                  }
                }
              }

              generic.focusErrors($('.js-error-messages'), $('.js-registration-container'));
              $this.removeClass('disabled');
            }
          });
        });
      }

      function buildCurrent() {
        var len = curApptData.length,
          locNode,
          dateNode,
          changeBtn,
          href;

        if (!len) {
          apptCont.append(noAppts);

          return;
        }
        apptCont.append(curAppts);
        curApptsCount = len;

        // go through and lump subsequent appts with their parent
        for (var t = 0; t < curApptData.length; t += 1) {
          var cOj = curApptData[t];

          if (cOj.services[0].subsequent == 1) {
            cOj.subsequent = '1';
            // If no parent then the subsequent appointment stands alone, do not remove it
            if (cOj.parent_appointment_id) {
              var pOj = curApptData.filter(function (obj, index) {
                return obj.id == cOj.parent_appointment_id;
              })[0];

              pOj.services = pOj.services.concat(cOj.services);
              pOj.subsequent = '1';
              curApptData.splice(t, 1);
              t -= 1; // Gotta do this since we just monkeyed with the array we are looping over
            }
          }
        }

        for (var i = 0; i < curApptData.length; i += 1) {
          var cAObj = curApptData[i],
            apptId = cAObj.id,
            isVirtual = cAObj.counter.calendars[0].virtual === '1' ? 1 : 0;

          (myAptNode = curApptTmpl.clone()),
            (lesNode = myAptNode.find('.your-lessons')),
            (locNode = isVirtual
              ? myAptNode.find('.location.virtual_oab_content')
              : myAptNode.find('.location.physical_oab_content')),
            (dateNode = myAptNode.find('.date-time')),
            (artNode = myAptNode.find('.artist')),
            (changeBtn = myAptNode.find('.change-appt-btn')),
            (cancelBtn = myAptNode.find('.cancel-appt-btn')),
            (href = changeBtn.attr('href'));

          myAptNode.attr('id', 'apptId_' + apptId);
          locNode.removeClass('hidden');
          buildCurrentLessons(lesNode, cAObj.services);
          if (isVirtual) {
            buildVirtualLocation(locNode, cAObj.virtual_meeting_link);
          } else {
            buildLocation(locNode, cAObj.counter);
          }
          buildDateTime(dateNode, cAObj, isVirtual);
          buildArtistName(artNode, cAObj.calendar);

          suppressLinks = cAObj.subsequent == '1';

          if (suppressLinks) {
            changeBtn.remove();
          } else {
            if (isVirtual) {
              changeBtn.attr('href', href + '?appointment_id=' + apptId + '&virtual=1');
              changeBtn.addClass('virtual-change-button');
            } else {
              changeBtn.attr('href', href + '?appointment_id=' + apptId);
            }
            changeBtn.click(function (e) {});
          }
          cancelBtn.attr('data-appt-id', apptId);

          cancelBtn.click(function (e) {
            var myId,
              $this = $(this);

            e.preventDefault();

            /* if ($this.hasClass('disabled')) {
              return;
            }

            $this.addClass('disabled');*/

            myId = $this.attr('data-appt-id');

            openOverlay(myId);
            $('.js-appt-book-overlay').find('.js-overlay-content-container').focus();
            site.restrict_navigation($('.js-overlay-content-container'));
          });

          curAppts.append(myAptNode);
        }
      }

      function buildPast() {
        var openH,
          closeH,
          locNode,
          dateNode,
          len = pastApptData.length;

        if (!len) {
          // pastAppts.remove();
          return;
        }
        apptCont.append(pastAppts);

        // go through and lump subsequent appts with their parent
        for (var t = 0; t < pastApptData.length; t += 1) {
          var cOj = pastApptData[t];

          // If no parent then the subsequent appointment stands alone, do not remove it
          if (cOj.services[0].subsequent == 1 && cOj.parent_appointment_id) {
            var pOj = pastApptData.filter(function (obj, index) {
              return obj.id == cOj.parent_appointment_id;
            })[0];

            pOj.services = pOj.services.concat(cOj.services);
            pastApptData.splice(t, 1);
            t -= 1; // Gotta do this since we just monkeyed with the array we are looping over
          }
        }

        for (var i = 0; i < pastApptData.length; i += 1) {
          var pAObj = pastApptData[i],
            apptId = pAObj.id,
            isVirtual = pAObj.counter.calendars[0].virtual === '1' ? 1 : 0;

          (myAptNode = pastApptTmpl.clone()),
            (lesNode = myAptNode.find('.your-lessons')),
            (locNode = isVirtual
              ? myAptNode.find('.location.virtual_oab_content')
              : myAptNode.find('.location.physical_oab_content')),
            (dateNode = myAptNode.find('.date-time')),
            (artNode = myAptNode.find('.artist-past'));

          myAptNode.attr('id', 'apptId_' + apptId);
          locNode.removeClass('hidden');
          buildLessons(lesNode, pAObj.services);
          if (!isVirtual) {
            buildLocation(locNode, pAObj.counter);
          }
          buildDateTime(dateNode, pAObj, isVirtual);
          buildArtistName(artNode, pAObj.calendar);

          pastAppts.append(myAptNode);
        }
        buildView(pastAppts, apptId);
      }

      function onApptsData(aData) {
        var now = new Date().getTime(),
          len = aData.length;

        if (!aData.length) {
          buildNoAppts();

          return;
        }

        curApptData = [];
        pastApptData = [];

        for (var i = 0; i < len; i += 1) {
          var aDObj = aData[i],
            aDate = me.convertTimeString(aDObj.start_time);

          aDObj.startDate = aDate;

          if (aDate.getTime() < now) {
            pastApptData.push(aDObj);
          } else {
            curApptData.push(aDObj);
          }
        }

        buildCurrent();
        buildPast();
      }

      function onUpdate() {
        apptCont.empty();
        generic.jsonrpc.fetch({
          method: 'user.json',
          // params: [],
          onSuccess: function (jsonRpcResponse) {
            userData = jsonRpcResponse.getValue();
            processUpdate();
          },
          onFailure: function (jsonRpcResponse) {
            processUpdate();
          }
        });

        function processUpdate() {
          if (userData && userData.signed_in) {
            isSignedIn = userData.signed_in;
          } else {
            isSignedIn =
              typeof site.userInfoCookie == 'undefined' ||
              _.isUndefined(site.userInfoCookie.getValue('signed_in')) ||
              site.userInfoCookie.getValue('signed_in') === null ||
              site.userInfoCookie.getValue('signed_in') == '0'
                ? 0
                : site.userInfoCookie.getValue('signed_in');
          }
          if (isSignedIn) {
            // Kick everything off with a call to getAuthToken
            getAuthToken(function (t) {
              getCounters();
              getAppointments(onApptsData);
            });
          } else {
            buildNoSignin();
          }
        }
      }

      onUpdate();
    },

    convertTimeString: function (tString) {
      var split, dateArray, timeArray, y, m, d, hr, min, sec;

      split = tString.split(' ');
      dateArray = split[0].split('-');
      timeArray = split[1].split(':');

      y = parseInt(dateArray[0], 10);
      m = parseInt(dateArray[1], 10) - 1;
      d = parseInt(dateArray[2], 10);
      hr = parseInt(timeArray[0], 10);
      min = parseInt(timeArray[1], 10);
      sec = parseInt(timeArray[2], 10);

      return new Date(y, m, d, hr, min, sec);
    }
  };

  Drupal.behaviors.ApptBookMyAppts = {
    attach: function (context) {
      if ($('#appointment-book-container').length) {
        apptBook.myAppts.init();
      }
    }
  };
})(jQuery);
